import React from 'react'

export default function SelectionIcon() {
  return (
    <svg width="12" height="21" viewBox="0 0 12 21" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 0v15.89l3.604-3.477L6.97 20.42l2.62-1.098-3.237-7.697H11.6"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}
